import { ColorShades, CromaticColors, Theme } from "@mui/material";

const handleColors = (
  key: any,
  theme: Theme,
  colorsByKey?: { [key: string]: string },
  colorsNivo?: { [key: string]: string }
) => {
  if (colorsByKey) {
    let findColorById = colorsByKey[key];
    if (!findColorById) {
      //verificacao para caso o key e os valores de colorByKeys estejam em diferentes formatos (minisculo e maiusculo)
      const isMin = Object.keys(colorsByKey).find(
        (k) => key?.toLowerCase() === k?.toLowerCase()
      );
      if (isMin) {
        key = isMin;
        findColorById = colorsByKey[key];
      }
    }

    //vericacao para saber se o valor da cor é um hexadecimal
    const isHex = (str: string) => /^(#|0x)?[0-9a-fA-F]+$/.test(str);

    if (isHex(findColorById)) {
      return findColorById;
    }

    //verifacao para saber se o valor da cor esta no formato "colorName.shade" (padrao para cores do tema)
    let colors = findColorById?.split(".");

    if (findColorById && colors.length > 1) {
      let result =
        theme.palette.cromatic[
          colors[0].toLocaleLowerCase() as keyof CromaticColors
        ][colors[1].toLocaleLowerCase() as keyof ColorShades];
      return result;
    }
  }
  return "#000000";
};
export default handleColors;
